import { z } from "zod";
import { PERSON_ROLES } from "../enums.ts";

export const PersonInput = z.object({
  name: z.string().min(1).max(200),
  hebrewName: z.string().max(200).nullable().optional(),
  crcCode: z.string().max(40).nullable().optional(),
  phone: z.string().max(60).nullable().optional(),
  email: z.string().email().max(200).nullable().optional(),
  agencyId: z.string().uuid().nullable().optional(),
  notes: z.string().max(4000).nullable().optional(),
  active: z.boolean().default(true),
  roles: z.array(z.enum(PERSON_ROLES)).default([]),
  legacySource: z.string().max(40).nullable().optional(),
  legacyId: z.string().max(120).nullable().optional(),
});
export type PersonInput = z.infer<typeof PersonInput>;

export const PersonUpdateInput = PersonInput.partial();

export const PersonQuery = z.object({
  q: z.string().max(200).optional(),
  role: z.enum(PERSON_ROLES).optional(),
  active: z.coerce.boolean().optional(),
});

export const ContractorAgencyInput = z.object({
  name: z.string().min(1).max(200),
  contact: z.string().max(400).nullable().optional(),
  active: z.boolean().default(true),
});
